import { Box, Stack } from '@mui/material';
import { keyframes } from '@mui/system';
import { reducedMotion } from '../styles';

const finaleGlow = keyframes`
    0%, 100% { box-shadow: 0 6px 16px rgba(16, 185, 129, 0.32); }
    50% { box-shadow: 0 8px 24px rgba(5, 150, 105, 0.5); }
`;

const CHIP_STYLES = [
    { color: '#115e59', bg: 'linear-gradient(180deg, #f0fdfa, #99f6e4)', border: 'rgba(13, 148, 136, 0.4)' },
    { color: '#1e40af', bg: 'linear-gradient(180deg, #eff6ff, #93c5fd)', border: 'rgba(37, 99, 235, 0.4)' },
    { color: '#6b21a8', bg: 'linear-gradient(180deg, #faf5ff, #d8b4fe)', border: 'rgba(147, 51, 234, 0.4)' },
    { color: '#9a3412', bg: 'linear-gradient(180deg, #fff7ed, #fdba74)', border: 'rgba(234, 88, 12, 0.42)' },
    { color: '#075985', bg: 'linear-gradient(180deg, #f0f9ff, #7dd3fc)', border: 'rgba(14, 165, 233, 0.42)' }
];

const FINALE_STYLE = {
    color: '#065f46',
    bg: 'linear-gradient(135deg, #6ee7b7, #10b981, #047857)',
    border: 'rgba(16, 185, 129, 0.6)'
};

interface FeaturePromoChipsProps {
    chips: string[];
    size?: 'compact' | 'large';
}

const FeaturePromoChips = ({ chips, size = 'compact' }: FeaturePromoChipsProps) => {
    const large = size === 'large';
    if (!chips.length) return null;

    return (
        <Stack
            direction="row"
            flexWrap="wrap"
            useFlexGap
            sx={{ gap: large ? 1 : 0.7, rowGap: large ? 1 : 0.75, width: '100%' }}
        >
            {chips.map((label, index) => {
                const last = index === chips.length - 1;
                const style = last ? FINALE_STYLE : CHIP_STYLES[index % CHIP_STYLES.length];
                return (
                    <Box
                        key={`${label}-${index}`}
                        sx={{
                            px: large ? 1.7 : 1.25,
                            py: large ? 0.7 : 0.42,
                            borderRadius: '999px',
                            fontWeight: 900,
                            fontSize: last ? (large ? 15 : 13) : large ? 14 : 12.5,
                            lineHeight: 1.25,
                            color: style.color,
                            background: style.bg,
                            border: `1px solid ${style.border}`,
                            boxShadow: last
                                ? '0 6px 16px rgba(16, 185, 129, 0.35)'
                                : '0 4px 10px rgba(14, 165, 233, 0.12)',
                            whiteSpace: 'nowrap',
                            animation: last ? `${finaleGlow} 2.4s ease-in-out infinite` : undefined,
                            [reducedMotion]: { animation: 'none' }
                        }}
                    >
                        {label}
                    </Box>
                );
            })}
        </Stack>
    );
};

export default FeaturePromoChips;
